import { clearPrefetched } from "./prefetchStorage";

/**
 * מוחק מטמון מגוון, תמונות ו-service worker caches — לפני רענון חזק.
 */
export async function clearAppCaches(storeId) {
  const tasks = [];
  if (storeId) tasks.push(clearPrefetched(storeId));
  if (typeof caches !== "undefined") {
    tasks.push(
      caches.keys().then((names) => Promise.all(names.map((name) => caches.delete(name))))
    );
  }
  await Promise.all(tasks);
}

/**
 * רענון חזק: מנקה React Query + מטמון מקומי, ואז:
 * - סניף: מוריד מגוון מחדש (PrefetchOrder)
 * - אחר: reload מלא של הדף
 */
export async function hardRefreshApp({ storeId, queryClient, navigate, returnPath }) {
  await queryClient.cancelQueries();
  queryClient.clear();
  await clearAppCaches(storeId);

  if (storeId) {
    const path = returnPath || `${window.location.pathname}${window.location.search}`;
    const returnTo = encodeURIComponent(path);
    navigate(`/prefetch-order?returnTo=${returnTo}&hard=1`, { replace: true });
    return;
  }

  const url = new URL(window.location.href);
  url.searchParams.set("_hr", String(Date.now()));
  window.location.replace(url.toString());
}
